/*
 * @Author: zhangcx33595
 * @Date: 2021-05-31 18:20:53
 * @LastEditors: zhangcx33595
 * @LastEditTime: 2021-06-01 15:02:01
 * @FilePath: \openplat-web\src\gtn\utils\parabola.js
 */
/**
 * js抛物线动画
 * @param  {[object]} origin [起点元素]
 * @param  {[object]} target [目标点元素]
 * @param  {[object]} element [要运动的元素]
 * @param  {[number]} radian [抛物线弧度]
 * @param  {[number]} time [动画执行时间]
 * @param  {[function]} callback [抛物线执行完成后回调]
 */
export class Parabola {
  constructor(config) {
    this.$ = selector => {
      return document.querySelector(selector);
    };
    this.b = 0;
    this.INTERVAL = 15;
    this.timer = null;
    this.config = config || {};
    // 起点
    this.origin = this.$(this.config.origin) || null;
    // 终点
    this.target = this.$(this.config.target) || null;
    // 运动的元素
    this.element = this.$(this.config.element) || null;
    // 曲线弧度
    this.radian = this.config.radian || 0.004;
    // 运动时间(ms)
    this.time = this.config.time || 1000;
    this.originX = this.origin.getBoundingClientRect().left;
    this.originY = this.origin.getBoundingClientRect().top;
    this.targetX = this.target.getBoundingClientRect().left;
    this.targetY = this.target.getBoundingClientRect().top;
    this.diffx = this.targetX - this.originX;
    this.diffy = this.targetY - this.originY;
    this.speedx = this.diffx / this.time;
    // 已知a, 根据抛物线函数 y = a*x*x + b*x + c 将抛物线起点平移到坐标原点[0, 0]，终点随之平移，那么抛物线经过原点[0, 0] 得出c = 0;
    // 终点平移后得出：y2-y1 = a*(x2 - x1)*(x2 - x1) + b*(x2 - x1)
    // 即 diffy = a*diffx*diffx + b*diffx;
    // 可求出常数b的值
    this.b =
      (this.diffy - this.radian * this.diffx * this.diffx) / this.diffx;
    // this.element.style.left = `${this.originX}px`;
    // this.element.style.top = `${this.originY}px`;
    // this.element.style.animation = 'bounce 1s .2s ease both'
  }

  // 确定动画方式
  moveStyle () {
    let moveStyle = 'position',
      testDiv = document.createElement('input');
    if ('placeholder' in testDiv) {
      ['', 'ms', 'moz', 'webkit'].forEach(function (pre) {
        var transform = pre + (pre ? 'T' : 't') + 'ransform';
        if (transform in testDiv.style) {
          moveStyle = transform;
        }
      });
    }
    return moveStyle;
  }

  move () {
    let start = new Date().getTime(),
      _this = this;

    if (this.timer) return;
    let i = 1.2
    this.timer = setInterval(function () {
      // 还原元素位置
      if (new Date().getTime() - start > _this.time) {
        // _this.element.style.left = `${_this.targetX}px`;
        //     _this.element.style.top = `${_this.targetY}px`;
        typeof _this.config.callback === 'function' &&
          _this.config.callback();
        clearInterval(_this.timer);
        _this.timer = null;
        return;
      }
      let x = _this.speedx * (new Date().getTime() - start);
      let y = _this.radian * x * x + _this.b * x;
      i = i > 0 ? i - 0.08 : 0
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(() => {
          _this.element.style.transform =
            'translate(' + x + 'px,' + y + 'px)' + ` scale(${i})`;
        });
      } else {
        _this.element.style =
          'translate(' + x + 'px,' + y + 'px)';
      }
    }, this.INTERVAL);
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/gtn/utils/parabola.js